module.exports = __webpack_public_path__ + "static/media/shopee_logo_en.f1a93120.png";